import { motion } from "framer-motion";
import { Eyebrow, LUX_EASE } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

function Line({ children, delay }) {
  return (
    <span className="block overflow-hidden pb-2">
      <motion.span
        className="block"
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, delay, ease: LUX_EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export default function PageHero({ eyebrow, title, body, image, imgAlt }) {
  const { t } = useLanguage();
  return (
    <section className="grain relative overflow-hidden pb-20 pt-40 md:pb-28 md:pt-52">
      {image && (
        <>
          <motion.img
            src={image}
            alt={imgAlt || ""}
            initial={{ scale: 1.08, opacity: 0 }}
            animate={{ scale: 1, opacity: 0.22 }}
            transition={{ duration: 2, ease: LUX_EASE }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-obsidian/70 via-obsidian/85 to-obsidian" />
        </>
      )}
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease: LUX_EASE }}
        >
          <Eyebrow>{eyebrow}</Eyebrow>
        </motion.div>
        <h1 className="text-shadow-lux mt-6 font-serif text-5xl leading-[1.06] text-cream sm:text-6xl lg:text-7xl">
          <Line delay={0.3}>{title}</Line>
        </h1>
        {body && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.75, ease: LUX_EASE }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-cream/70 sm:text-lg"
          >
            {body}
          </motion.p>
        )}
        <motion.span
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1.1, delay: 0.5, ease: LUX_EASE }}
          className="mt-10 block h-px w-28 origin-left bg-gold/70"
          aria-hidden="true"
        />
      </div>
      <span className="sr-only">{t.nav.home}</span>
    </section>
  );
}
